export enum MidRangeType {
    Default,
    Team,
    Organization,
    All
}


// WEBPACK FOOTER //
// ./src/enums/MidRangeType.tsx